<template>
  <div class="content">
    <DataReportSelect selectTabsType="frequencyData" @event-filter="fetchData">
      <span slot="frequencyData">
          <div class="btn-group-wrap">
            <el-radio-group v-model="model.queryType" size="mini" class="btn-group">
              <el-radio-button :label="0">PV</el-radio-button>
              <el-radio-button :label="1">UV</el-radio-button>
              <el-radio-button :label="2">UV%</el-radio-button>
              <el-radio-button :label="3">N+UV</el-radio-button>
              <el-radio-button :label="4">N+UV%</el-radio-button>
            </el-radio-group>
          </div>
        <div class="charts-warp">
          <div class="charts-container">
            <el-row>
              <ContentBox title="到达曲线">
                <VeLine
                  :data="reachLine.data"
                  :settings="reachLine.settings"
                  :extend="reachLine.extend"
                  :legend-visible="false"
                  :colors="['#23ccd6']"
                  :loading="loading"
                  height="300px"
                >
                  <ChartDataEmpty v-if="reachLine.data.rows.length === 0" />
                </VeLine>
              </ContentBox>
            </el-row>
            <!-- <el-row style="margin-top:20px;border-radius: 10px 10px 0px 0px">
            <el-col>-->
            <ContentBox>
              <div class="download" slot="title">
                <p class="title">曝光数据</p>
                <div class="title-right">
                  <p class="title-right-radio">
                    数据维度
                    <el-checkbox-group class="check-wrap" v-model="model.groupTypeList">
                      <el-checkbox label="schedule">计划单</el-checkbox>
                      <el-checkbox label="province_name">省份</el-checkbox>
                      <el-checkbox label="city_name">城市</el-checkbox>
                    </el-checkbox-group>
                  </p>
                  <!-- <el-button size="small" class="el-icon-s-fold">自定义列</el-button> -->
                  <p>
                    <el-button size="mini" @click="handleOpen()">
                      <i class="el-icon-cc-unorderedlist" style="font-size: 12px;padding-right:4px"></i>导出
                    </el-button>
                  </p>
                </div>
              </div>
              <div>
                <Table :props="table.props" :header="table.header" @sort-change= "sortTableFun" :data="table.data" />
                <pagination
                  :currentpage="currentPage"
                  :pagesize="pageSize"
                  :totalcount="totalCount"
                  @handle-size-change="handleSizeChange"
                  @handle-current-change="handleCurrentChange"
                ></pagination>
              </div>
            </ContentBox>
            <!-- </el-col>
            </el-row>-->
          </div>
        </div>
      </span>
    </DataReportSelect>
    <el-dialog :visible.sync="showDialogForm" :show-close="true" width="60%" title="导出">
      <el-form label-width="120px" :rules="rules" ref="fileForm" :model="exportModel">
                <el-form-item label="明细" prop="queryTypeList">
                  <el-checkbox-group size="mini" v-model="exportModel.queryTypeList">
                    <el-checkbox v-for="(item, index) in detailOption" :label="item.value" :key="item.value">{{ item.label }}</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="文件名称" prop="fileName">
                  <el-input v-model="exportModel.fileName" :maxlength="100" placeholder="请输入文件名称"></el-input>
                </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click="handleCancel">取消</el-button>
          <el-button type="primary" :loading="loadingExport" @click="handleConfirm">保存</el-button>
        </span>
    </el-dialog>
  </div>
</template>
<script>
import { InputPositiveInt, Table } from '@ccprivate/admin-toolkit'
import DataReportSelect from '@/components/DataReportSelect'
import ChartDataEmpty from '@/components/ChartDataEmpty'
import VeLine from 'v-charts/lib/line.common'
import 'v-charts/lib/style.css'
import downLoad from '@/utils/downLoad'
export default {
  inject: ['searchData'],
  components: {
    Table,
    DataReportSelect,
    VeLine,
    ChartDataEmpty
  },
  data() {
    return {
      rules: {
        fileName: [
          { required: true, message: '请输入文件名称', trigger: 'blur' }
        ],
        queryTypeList: [
          { required: true, message: '请选择', trigger: 'blur' }
        ]
      },
      fileRules: {
        fileName: {
          required: true,
          maxLength: 100
        },
        queryTypeList: {
          required: true
        },
      },
      loadingExport: false,
      detailOption: [
        { value: 0, label: 'PV' },
        { value: 1, label: 'UV' },
        { value: 2, label: 'UV%' },
        { value: 3, label: 'N+UV' },
        { value: 4, label: 'N+UV%' },
      ],
      exportModel: {
        fileName: '',
        queryTypeList: []
      },
      showDialogForm: false,
      exportLoading: false,
      tableTotal: 0, // 共多少条
      tableData: [],
      timeList: [
        { date: [] }
      ],
      selectOrderList: [], // 选中的订单
      selectScheduleList: [], // 选中的计划单
      inputOrders: [],
      inputSchedules: [],
      searchLoading: false,
      model: {
        orderNoList: [], // 订单号列表
        scheduleNoList: [], // 计划单号列表
        // dspType: 1,
        orderId: '',
        scheduleId: '',
        beginDate: '',
        endDate: '',
        statType: 0, // 统计类型：0 按订单，1按计划单
        groupTypeList: ['date', 'order'], // 数据维度
        pageNo: 1,
        pageSize: 10,
        date: undefined,
        channel: undefined,
        queryType: 0,
        dateType: 0,
      },
      isShowSelect: false,
      isShowTimePicker: false,
      showType: 1,
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      frequencyMaxTimes: 20,
      sort: {
        key: 'totalTime',
        type: 'desc'
      },
      // 到达数据曲线
      reachLine: {
        data: {
          columns: ['xData', 'yData'],
          rows: []
        },
        settings: {
          labelMap: { yData: '展示数' },
          yAxisName: ['pv']
        },
        extend: this.$consts.basicLineExtend
      },
      table: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '日期',
            align: 'center',
            sortable: true,
            prop: 'totalTime',
            'width': 200,
            'show-overflow-tooltip': true
          }, {
            label: '订单编号',
            align: 'center',
            prop: 'orderNo',
            'min-width': 120,
            // sortable: true,
            'show-overflow-tooltip': true
          }, {
            label: '订单名称',
            align: 'center',
            prop: 'orderName',
            'min-width': 120,
            'show-overflow-tooltip': true
          }
        ],
        data: []
      },
      loading: false
      // screenWidth: document.documentElement.clientWidth,
      // sortHeight: 76
    }
  },
  watch: {
    'model.groupTypeList': function () {
      if (this.model.groupTypeList.length > 0) {
        this.initSort()
      }
    },
    'searchData.model': {
      handler(val) {
        this.model.scheduleNoList = val.scheduleNo ? [val.scheduleNo] : []
        this.model.orderNoList = val.orderNo ? [val.orderNo] : []
        this.model.scheduleId = val.scheduleId
        this.model.orderId = val.orderId
        if (this.searchData.time && this.searchData.time[0]) {
          this.model.date = [this.$moment(this.searchData.time[0]).format(
            'YYYY-MM-DD'
          ), this.$moment(this.searchData.time[1]).format(
            'YYYY-MM-DD'
          )]
          this.model.beginDate = this.model.date[0]
          this.model.endDate = this.model.date[1]
        }
        this.model.statType = this.model.scheduleId ? 1 : 0
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    groupTypeOptions() {
      let options = []
      if (this.model.statType === 1) {
        options.push({ value: 'schedule', label: '计划单', fields: ['scheduleNo', 'scheduleName'] })
      } else {
        options.push({ value: 'order', label: '订单', fields: ['orderNo', 'orderName'] })
        options.push({ value: 'schedule', label: '计划单', fields: ['scheduleNo', 'scheduleName'] })
      }
      options = options.concat([
        { value: 'province_name', label: '省份', fields: ['provinceName'] },
        { value: 'city_name', label: '城市', fields: ['cityName'] }
      ])
      return options
    },
  },
  methods: {
    sortTableFun(column) {
      // 用户点击这一列的上下排序按钮时，触发的函数
      let prop = column.prop; // 该方法获取到当前列绑定的prop字段名赋值给一个变量，之后这个变量做为入参传给后端
      if (column.prop) { // 该列有绑定prop字段走这个分支
        if (column.order == 'ascending') { // 当用户点击的是升序按钮，即ascending时
          this.sort = {
            key: prop || 'totalTime',
            type: 'asc'
          }
        } else if (column.order == 'descending') {
          this.sort = {
            key: prop || 'totalTime',
            type: 'desc'
          }
        } else {
          this.sort = {
            key: 'totalTime',
            type: 'desc'
          }
        }
      }
      this.currentPage = 1
      this.getTableData()
    },
    getFreqMaxTimes() {
      // http.post('admin/adSystemSetting/data', { settingKey: 'frequency_max_times' }).then(res => {
      //   if (res.code === 0 && res.data) {
      //     this.frequencyMaxTimes = parseInt(res.data.settingValue, 10)
      //   }
      // })
    },
    initSort() {
      if (this.model.groupTypeList.includes('date')) {
        this.sort.key = 'totalTime'
      } else {
        this.sort.key = this.model.queryType === 0 ? 'allPv' : 'allUv'
      }
      this.sort.type = 'desc'
    },
    exporeTabelHeader() {
      let queryType = ['PV', 'UV', 'UV%', 'N+UV', 'N+UV%'][this.model.queryType]
      const queryTypeField = this.model.queryType === 0 ? 'allPv' : 'allUv'
      let scheme = [
        {
          label: '日期',
          align: 'center',
          prop: 'totalTime',
          'min-width': 120,
          sortable: true,
          'show-overflow-tooltip': true
        }, {
          label: '订单编号',
          align: 'center',
          prop: 'orderNo',
          'min-width': 150,
          // sortable: true,
          'show-overflow-tooltip': true
        }, {
          label: '订单名称',
          prop: 'orderName',
          'min-width': 150,
          'show-overflow-tooltip': true
        }, {
          label: '计划单编号',
          align: 'left',
          prop: 'scheduleNo',
          'width': 150,
          // sortable: true,
          'show-overflow-tooltip': true
        }, {
          label: '计划单名称',
          prop: 'scheduleName',
          'min-width': 150,
          'show-overflow-tooltip': true
        }, {
          label: '省份',
          align: 'right',
          prop: 'provinceName',
          'min-width': 120,
          'show-overflow-tooltip': true
        }, {
          label: '城市',
          align: 'right',
          prop: 'cityName',
          'min-width': 120,
          'show-overflow-tooltip': true
        }
      ]
      scheme.push({
        label: `总${queryType !== 'PV' ? 'UV' : queryType}`,
        align: 'right',
        prop: queryTypeField,
        'width': 160,
        // sortable: true,
        'show-overflow-tooltip': true
      })
      // 处理数据维度在表格的显示
      // 处理数据维度在表格的显示
      const groupTypeOptions = this.cloneDeep(this.groupTypeOptions)
      if (this.model.statType === 0 && !this.model.groupTypeList.includes('schedule')) {
        scheme = scheme.filter(item => !['scheduleNo', 'scheduleName'].includes(item.prop))
      }
      if (!this.model.groupTypeList.includes('province_name')) {
        scheme = scheme.filter(item => !['provinceName'].includes(item.prop))
      }
      if (!this.model.groupTypeList.includes('city_name')) {
        scheme = scheme.filter(item => !['cityName'].includes(item.prop))
      }
      if (this.model.statType === 1) {
        scheme = scheme.filter(item => !['orderNo', 'orderName'].includes(item.prop))
      }
      if (this.model.statType === 1 && !this.model.groupTypeList.includes('schedule')) {
        scheme = scheme.filter(item => !['scheduleNo', 'scheduleName'].includes(item.prop))
      }
      for (let i = 1; i <= this.frequencyMaxTimes; i++) {
        let prop = `${queryType.toLowerCase()}${i}`
        let title = ''
        if (['N+UV', 'N+UV%'].includes(queryType)) {
          prop = `uv${i}`
          title = `曝光${i}+${queryType.slice(2)}`
        } else {
          title = i === this.frequencyMaxTimes ? `曝光${i}次及以上${queryType}` : `曝光${i}次${queryType}`
        }
        scheme.push({
          label: title,
          align: 'right',
          prop: prop,
          'width': 160,
          'show-overflow-tooltip': true,
          render: (h, { row }) => {
            return queryType === 'UV%' ? row[`uv${i}`] : row[prop]
          }
        })
      }
      if (['N+UV', 'N+UV%'].includes(queryType)) {
        scheme = scheme.filter(item => !['uv1'].includes(item.prop))
      }
      this.table.header = scheme
    },
    async handleConfirm() {
      await this.$refs.fileForm.validate((valid) => {
        if (valid) {
          this.handleExport()
        }
      })
    },
    handleCancel() {
      this.showDialogForm = false
    },
    handleOpen() {
      if (!this.searchData.model.orderId) {
        this.$message.error('请选择订单')
        return
      }
      if (!this.checkParam()) return
      this.exportModel.queryTypeList = [this.model.queryType]
      this.showDialogForm = true
    },
    handleExport() {
      if (this.searchData.time && this.searchData.time[0]) {
        this.model.date = [this.$moment(this.searchData.time[0]).format(
          'YYYY-MM-DD'
        ), this.$moment(this.searchData.time[1]).format(
          'YYYY-MM-DD'
        )]
      } else {
        this.model.date = null
      }
      this.showType = this.searchData.model.showType
      this.model.dateType = this.searchData.model.showType
      this.model.orderId = this.searchData.model.orderId
      this.model.scheduleId = this.searchData.model.scheduleId
      if (!this.model.scheduleId) {
        delete this.model.scheduleId
      }
      this.loadingExport = true
      const param = this.dealParam(this.model, 'export')
      delete param.orderId
      delete param.scheduleId
      if (this.model.statType === 0) {
        delete param.scheduleNoList
      } else {
        delete param.orderNoList
      }
      param.exportTag = 0
      param.fileName = this.exportModel.fileName
      param.queryTypeList = this.exportModel.queryTypeList.sort((a, b) => a - b)
      if (this.model.groupTypeList.includes('date')) {
        param.sortList = param.queryTypeList.map((item, index) => {
          return this.model.queryType === item ? this.sort.key : 'totalTime'
        })
      } else {
        param.sortList = param.queryTypeList.map((item, index) => {
          let y = item === 0 ? 'allPv' : 'allUv'
          return this.model.queryType === item ? this.sort.key : y
        })
      }
      param.orderList = param.queryTypeList.map((item, index) => {
        return this.model.queryType === item ? this.sort.type : 'desc'
      })
      delete param.pageSize
      const options = {
        url: 'api/dsp/frequency/exportExcel',
        data: param
      }
      downLoad(options)
        .then(res => {
          this.showDialogForm = false
          this.loadingExport = false
        })
        .catch(() => {
          this.showDialogForm = false
          this.loadingExport = false
        })
    },
    handleSizeChange: function (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getTableData()
    },
    // 页码变更, 如第1页变成第2页时,val=2
    handleCurrentChange: function (val) {
      this.currentPage = val
      this.getTableData()
    },
    fetchData() {
      this.currentPage = 1
      this.getTableData()
    },
    checkParam() {
      let isValid = true
      if (this.model.groupTypeList.includes('date')) {
        if ([1, 2].includes(this.model.dateType) && (!this.model.date || this.model.date.length === 0)) {
          this.$message.error('请选择日期范围')
          isValid = false
        }
        const timeList = this.timeList.filter(item => item.date && item.date.length === 2)
      }
      return isValid
    },
    checkRepeatDates(timeList) {
      let dates = []
      timeList.forEach(item => {
        dates = dates.concat(this.getBetweenDate(item.date[0], item.date[1]))
      })
      return uniq(dates).length === dates.length
    },
    getBetweenDate(start, end) {
      let result = []
      let startTime = moment(start).format('YYYY-MM-DD')
      const endTime = moment(end).format('YYYY-MM-DD')
      while (moment(startTime).isSameOrBefore(endTime)) {
        result.push(startTime)
        startTime = moment(startTime).add(1, 'days').format('YYYY-MM-DD')
      }
      return result
    },
    dealParam(val, type) {
      const param = this.cloneDeep(val)
      if (this.model.groupTypeList.includes('date')) {
        if (this.model.date && this.model.date.length) {
          param.beginDate = this.model.date[0]
          param.endDate = this.model.date[1]
        } else {
          param.beginDate = undefined
          param.endDate = undefined
        }
      }
      // delete param.date
      if (type !== 'export') {
        param.order = this.sort.type
        param.sort = this.sort.key
      }
      return param
    },
    // 详细数据
    getTableData() {
      this.model.pageNo = this.currentPage
      if (!this.searchData.model.orderId) {
        this.$message.error('请选择订单')
        return
      }
      this.exporeTabelHeader()
      if (this.searchData.time && this.searchData.time[0]) {
        this.model.date = [this.$moment(this.searchData.time[0]).format(
          'YYYY-MM-DD'
        ), this.$moment(this.searchData.time[1]).format(
          'YYYY-MM-DD'
        )]
      } else {
        this.model.date = null
      }
      this.showType = this.searchData.model.showType
      this.model.dateType = this.searchData.model.showType
      this.model.orderId = this.searchData.model.orderId
      this.model.scheduleId = this.searchData.model.scheduleId
      if (!this.checkParam()) return
      const param = this.dealParam(this.model)
      if (this.model.dateType === 6) {
        delete param.beginDate
        delete param.endDate
      }
      param.exportTag = 1
      this.loading = true
      if (!param.beginDate) {
        delete param.beginDate
        delete param.endDate
      }
      delete param.orderId
      delete param.scheduleId
      if (this.model.statType === 0) {
        delete param.scheduleNoList
      } else {
        delete param.orderNoList
      }
      delete param.date
      this.$service.getFrequencyList(param).then((res) => {
        this.loading = false
        this.tableTotal = res.total
        this.tableData = (res.rows || []).map(item => {
          if (this.model.dateType === 6) {
            item.totalTime = '合计'
          }
          return item
        })
        this.table.data = res.rows || []
        this.totalCount = res.total
      })
      if (param.pageNo !== 1) { return; }
      // 到达曲线
      let param1 = this.cloneDeep(param)
      if (this.model.dateType === 6) {
        delete param1.beginDate
        delete param1.endDate
      }
      param1.dateType = 6
      this.$service.getFrequencyList(param1).then((res) => {
        this.loading = false
        let scheme = []
        let queryType = ['PV', 'UV', 'UV%', 'N+UV', 'N+UV%'][this.model.queryType]
        let row = res.rows[0] || {}
        for (let i = 1; i <= this.frequencyMaxTimes; i++) {
          let prop = `${queryType.toLowerCase()}${i}`
          let title = ''
          if (['N+UV', 'N+UV%'].includes(queryType)) {
            prop = `uv${i}`
            title = `${i}+${queryType.slice(2)}`
          } else {
            title = i === this.frequencyMaxTimes ? `${i}次及以上${queryType}` : `${i}次${queryType}`
          }
          let yData = 0
          if (Object.keys(row).length) {
            yData = parseFloat(queryType === 'UV%' ? (row[`uv${i}`] || 0) : (row[prop] || 0))
          } else {
            yData = 0
          }
          scheme.push({
            xData: title,
            prop: prop,
            unit: '',
            yData
          })
        }
        if (['N+UV', 'N+UV%'].includes(queryType)) {
          scheme = scheme.filter(item => !['uv1'].includes(item.prop))
        }
        this.reachLine.data.rows = scheme
      })
    }
  },
  created() {
    if (this.searchData.isFilter) {
      this.fetchData()
    }
  },
  mounted() {
    this.$EventBus.$on('clear-filter', (e) => {
      this.table.data = []
      this.reachLine.data.rows = []
    });
  }
}
</script>
<style lang="stylus" scoped>
.btn-group-wrap {
  padding 10px 32px
  margin-bottom 16px
  background #ffffff
  text-align right
}
.content
  position relative
.header-serach
  position relative
.charts-warp
  display flex
  flex 1
.charts-container
  width 100%
  height 100%
  margin 0 16px
p
  margin 0
>>> .el-radio-button--medium .el-radio-button__inner
  min-width 100px
.download
  width 100%
  display flex
  justify-content space-between
  padding-right 20px
  align-items center
.title-right
  display flex
  align-items center
.title-right-radio
  display flex
  padding 4px 10px
  border 1px solid #DCDFE6
  border-radius 4px
  font-size 14px
  color #606266
  margin-right 10px
  .check-wrap {
    margin-left 10px
  }
</style>
